import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import Footer from '../components/partials/Footer';
import DashMenu from '../components/views/Dashboard/partials/DashMenu';

import '../css/dash.css';

class DashboardLayout extends Component {
  render() {
    return (
      <div>
        <Helmet onClientStateChange={(newState) => this.setState({ title: newState.title }) } />
        <div className="dashboard">
          <DashMenu />
          {this.props.children}
        </div>
        <Footer />
      </div>
    );
  }
}

export default DashboardLayout;



// WEBPACK FOOTER //
// ./src/containers/DashboardLayout.js